import styled from 'styled-components';
import tinycolor from 'tinycolor2';

type GradientTextProps = {
  $color1?: string;
  $color2?: string;
  $isAnimated?: boolean;
};

export const GradientText = styled.span<GradientTextProps>`
  background: repeating-linear-gradient(
    90deg,
    ${({ theme, $color1 }) =>
      $color1 || tinycolor(theme.token.colorPrimary).lighten(10).toHexString()},
    ${({ theme, $color2 }) =>
      $color2 || tinycolor(theme.token.colorPrimary).lighten(10).toHexString()},
    ${({ theme, $color1 }) =>
      $color1 || tinycolor(theme.token.colorPrimary).lighten(13).toHexString()}
  );
  background-size: 200% 100%;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ${({ $isAnimated }) =>
    $isAnimated ? 'GradientAnimation 6s linear infinite' : 'none'};

  @keyframes GradientAnimation {
    0% {
      background-position: 0% 50%;
    }
    100% {
      background-position: -200% 50%;
    }
  }
`;
